import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0dfe6558"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-3 m-t" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("p", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["btn btn-primary", { disabled: !_ctx.activePointIsPinnable }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('pinPanoramaToActivePoint')))
    }, " Привязать ", 2),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["btn btn-default", { disabled: !_ctx.activePointIsUnpinnable }]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('unpinPanoramaFromActivePoint')))
    }, " Отвязать ", 2),
    _hoisted_2,
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["btn btn-default", { disabled: !_ctx.hasPreviousPanorama }]),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('setPreviousPanoramaActive')))
    }, " Назад ", 2),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["btn btn-default", { disabled: !_ctx.hasNextPanorama }]),
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('setNextPanoramaActive')))
    }, " Вперед ", 2),
    _hoisted_3,
    _createElementVNode("button", {
      type: "button",
      class: "shooting-pin-controls__create-point-button btn btn-info",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('callCreatePoint')))
    }, " Создать точку съемки ")
  ]))
}